var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.25 1H8.75C9.02614 1 9.25 1.22386 9.25 1.5V10.5C9.25 10.7761 9.02614 11 8.75 11H3.25C2.97386 11 2.75 10.7761 2.75 10.5V1.5C2.75 1.22386 2.97386 1 3.25 1ZM6 10.5C6.27614 10.5 6.5 10.2761 6.5 10C6.5 9.72386 6.27614 9.5 6 9.5C5.72386 9.5 5.5 9.72386 5.5 10C5.5 10.2761 5.72386 10.5 6 10.5ZM3.5 2C3.5 1.86193 3.61193 1.75 3.75 1.75H8.25C8.38807 1.75 8.5 1.86193 8.5 2V9C8.5 9.13807 8.38807 9.25 8.25 9.25H3.75C3.61193 9.25 3.5 9.13807 3.5 9V2Z","fill":"#424242"}));
}

Mobile.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Mobile;

Mobile.default = Mobile;
